import { useAuditReportsGetGipMetadataCustomFields } from '@mi-front/api-v2';

/**
 * Custom field keys for the GIP form via api-v2 (client-global metadata).
 */
export function useGipCustomFieldsQuery(_params: { stations: string[] }) {
  return useAuditReportsGetGipMetadataCustomFields({
    query: {
      select: (customFields) => customFields.filter((v) => !!v),
    },
  });
}
